'use client'

import { useState } from 'react'

interface UseAccordionProps {
	initialExpanded?: boolean
	initialExpandedKey?: string
	allowMultiple?: boolean
}

interface UseAccordionReturn {
	expandedProgram: string | null
	toggleAccordion: (programKey: string) => (e: React.MouseEvent) => void
	expandedClass: (programKey: string) => string
}

export const useAccordion = ({
	initialExpanded = false,
	initialExpandedKey = 'basic'
}: UseAccordionProps = {}): UseAccordionReturn => {
	const [expandedProgram, setExpandedProgram] = useState<string | null>(
		initialExpanded ? initialExpandedKey : null
	)

	const toggleAccordion = (programKey: string) => (e: React.MouseEvent) => {
		e.preventDefault()
		setExpandedProgram(expandedProgram === programKey ? null : programKey)
	}

	return {
		expandedProgram,
		toggleAccordion,
		expandedClass: (programKey: string) => (expandedProgram === programKey ? 'expanded' : '')
	}
}
